import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Avatar from '@deprecated-ui/common/Avatar';
import Image from 'global/Image';
import { handleErrorAvatar } from 'utils/general';
import { AVATAR_URL } from 'constants/api';
import { PlaceHolder } from '../styled';
import CommentSetting from '../CommentSetting';
import { CommenterState } from '../types';
import { COMPOSE_MODE } from '../constants';

interface HeaderProps {
  avatar: string;
  username: string;
  isExpand: boolean;
  commenter: any;
  mode: string;
  onExpand: () => void;
  onChangeCommenter: (data: CommenterState) => void;
}

function Header({
  avatar,
  username,
  isExpand,
  commenter,
  mode,
  onExpand,
  onChangeCommenter,
}: HeaderProps) {
  const commentSettingZIndex = mode === COMPOSE_MODE.COMPOSE ? 20 : 99999;
  const avatarUrl = avatar?.startsWith('http')
    ? avatar
    : `${AVATAR_URL}/${avatar}`;

  return (
    <Flex padding={isExpand ? '20px 20px 0 20px' : '20px'}>
      <Avatar size="medium">
        <Image
          alt="avatar"
          src={avatarUrl}
          onError={(e) => handleErrorAvatar(e, username)}
        />
      </Avatar>
      {isExpand ? (
        // @ts-expect-error
        <Flex ml="20px" justify="center" direction="column">
          {/* @ts-expect-error */}
          <Text family="bold" size="16px" mb="2px">
            {username}
          </Text>
          <CommentSetting
            commenter={commenter}
            zIndex={commentSettingZIndex}
            onChangeCommenter={onChangeCommenter}
          />
        </Flex>
      ) : (
        <PlaceHolder
          onClick={onExpand}
          data-cy="stream-compose-textarea-header"
        >
          Tulis ide kamu disini...
        </PlaceHolder>
      )}
    </Flex>
  );
}

export default Header;
